import { BlockTransformContext, StoryblokBlock } from '~/lib/storyblok'

export async function transformGallerySelectionBlock(block: StoryblokBlock, { props, options }: BlockTransformContext) {
  return {
    ...props,
    title: block.title,
    pages: block.pages,
    options: {
      ...options,
      order: block.option_order || 'text_image',
    },
  }
}
